import { createFileRoute } from "@tanstack/react-router";

import { IntegrationKeysPage } from "../../pages/settings/IntegrationKeys.page";

// `settings_` keeps this route out of the `/settings` layout: that page is the
// local-auth password form and renders no outlet.
export const Route = createFileRoute("/_protected/settings_/integration-keys")({
  component: IntegrationKeysPage,
});
